const Loader = () => {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="w-12 h-12 border-4 border-primary border-solid border-t-transparent rounded-full animate-spin"></div>
        </div>
    )
}

export default Loader
